export default "__VITE_ASSET__fd22cb34__"